import { z } from "zod"
import { BusinessTypeEnum } from "~/__generated__/graphql"

export const buildFormSchema = ({
  hasExistingLogo,
}: {
  hasExistingLogo: boolean
}) =>
  z.object({
    agency: z.object({
      logo: z
        .union([z.literal(undefined), z.literal(null), z.string()])
        .superRefine((value, ctx) => {
          if (typeof value === "string") {
            if (value.length === 0) {
              ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Logo is required",
              })
            }
            return
          }
          if (value === null || !hasExistingLogo) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: "Logo is required",
            })
          }
        }),
      name: z.string().trim().min(1, "Agency name is required"),
      agentName: z.string().trim().min(1, "Contact name is required"),
      contactEmail: z
        .string()
        .trim()
        .min(1, "Email is required")
        .email({ message: "Please enter a valid email" }),
      website: z.union([
        z.literal(""),
        z.string().trim().url({ message: "Please enter a valid URL" }),
      ]),
      phone: z.string().trim(),
      businessType: z
        .string()
        .optional()
        .refine(
          (value) =>
            !value || Object.values(BusinessTypeEnum as any).includes(value),
          "Please select a valid business type"
        ),
    }),
  })

export type FormValues = z.infer<ReturnType<typeof buildFormSchema>>
